import {Dispatch} from "redux";
import {
  WHEEL_HASH_CONSUME_FAIL,
  WHEEL_HASH_CONSUME_RESET,
  WHEEL_HASH_CONSUME_START,
  WHEEL_HASH_CONSUME_SUCCESS,
  WHEEL_HASH_DETAIL_FETCH_FAIL,
  WHEEL_HASH_DETAIL_FETCH_RESET,
  WHEEL_HASH_DETAIL_FETCH_START,
  WHEEL_HASH_DETAIL_FETCH_SUCCESS
} from "../constants/wheel";
import {ErrorDto, ErrorGeneric, getErrorDtoFromApiError} from "../models/dtos/error.dto";
import {HashDetailDto} from "../models/dtos/hashDetail.dto";
import WheelService from "../services/wheel.service";
import {
  WheelHashConsumeFailAction,
  WheelHashConsumeResetAction,
  WheelHashConsumeStartAction,
  WheelHashConsumeSuccessAction,
  WheelHashDetailFetchFailAction,
  WheelHashDetailFetchResetAction,
  WheelHashDetailFetchStartAction,
  WheelHashDetailFetchSuccessAction
} from "../types/wheel";

const wheelService: WheelService = new WheelService();

/**
 * WHEEL_HASH_DETAIL
 */
const wheelHashDetailFetchStartAction = (): WheelHashDetailFetchStartAction => {
  return {
    type: WHEEL_HASH_DETAIL_FETCH_START,
  }
}
const wheelHashDetailFetchSuccessAction = (payload: HashDetailDto): WheelHashDetailFetchSuccessAction => {
  return {
    type: WHEEL_HASH_DETAIL_FETCH_SUCCESS,
    payload: payload,
  }
}
const wheelHashDetailFetchFailAction = (error: ErrorDto): WheelHashDetailFetchFailAction => {
  return {
    type: WHEEL_HASH_DETAIL_FETCH_FAIL,
    error: error,
  }
}
export const wheelFetchHashDetail = (hash: string) => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(wheelHashDetailFetchStartAction());
    const hashDetail = await wheelService.getHash(hash);
    if (hashDetail) {
      dispatch(wheelHashDetailFetchSuccessAction(hashDetail));
    } else {
      dispatch(wheelHashDetailFetchFailAction(ErrorGeneric));
    }
  } catch (error) {
    dispatch(wheelHashDetailFetchFailAction(getErrorDtoFromApiError(error)));
  }
}

const wheelHashDetailFetchResetAction = (): WheelHashDetailFetchResetAction => {
  return {
    type: WHEEL_HASH_DETAIL_FETCH_RESET,
  }
}
export const wheelResetHashDetail = () => (
  dispatch: Dispatch
) => {
  dispatch(wheelHashDetailFetchResetAction());
}

/**
 * WHEEL_HASH_CONSUME
 */
const wheelHashConsumeStartAction = (): WheelHashConsumeStartAction => {
  return {
    type: WHEEL_HASH_CONSUME_START,
  }
}
const wheelHashConsumeSuccessAction = (payload: boolean): WheelHashConsumeSuccessAction => {
  return {
    type: WHEEL_HASH_CONSUME_SUCCESS,
    payload: payload,
  }
}
const wheelHashConsumeFailAction = (error: ErrorDto): WheelHashConsumeFailAction => {
  return {
    type: WHEEL_HASH_CONSUME_FAIL,
    error: error,
  }
}
export const wheelConsumeHash = (hash: string) => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(wheelHashConsumeStartAction());
    await wheelService.consume(hash);
    dispatch(wheelHashConsumeSuccessAction(true));
  } catch (error) {
    dispatch(wheelHashConsumeFailAction(getErrorDtoFromApiError(error)));
  }
}

const wheelHashConsumeResetAction = (): WheelHashConsumeResetAction => {
  return {
    type: WHEEL_HASH_CONSUME_RESET,
  }
}
export const wheelResetHashConsume = () => (
  dispatch: Dispatch
) => {
  dispatch(wheelHashConsumeResetAction());
}
